// App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import RedditCommentSkeleton from './components/ThreadViewScreen/RedditCommentSkeleton';
import ReplyScreen from './components/ReplyScreen/ReplyScreen';
import UsernameScreen from './components/UsernameScreen/UsernameScreen';
import RedditListView from './components/RedditListView';
import './App.css';
// import './components/CommentContent.css';

const RedditCommentSkeletonWrapper = () => {
  const { id } = useParams<{ id: string }>();
  return <RedditCommentSkeleton id={id || '1'} />;
};

const ReplyScreenWrapper = () => {
  const { id } = useParams<{ id: string }>();
  return <ReplyScreen id={id || '1'} />;
};

const App: React.FC = () => {
  return (
    <Router>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<UsernameScreen />} />
        <Route path="/posts" element={<RedditListView />} />
        <Route path="/comment/:id" element={<RedditCommentSkeletonWrapper />} />
        <Route path="/reply/:id" element={<ReplyScreenWrapper />} />
      </Routes>
    </Router>
  );
};

export default App;